const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.midwestrailbirds.com'

export interface Memorial {
  id: string
  name: string
  memberSince: number
  passedAway: number
  yearsActive: number
  bio: string
  contributions: string[]
  photo?: string
  createdAt: string
  updatedAt: string
}

export interface CreateMemorialData {
  name: string
  memberSince: number
  passedAway: number
  yearsActive?: number
  bio: string
  contributions: string[]
  photo?: string
}

export interface UpdateMemorialData extends Partial<CreateMemorialData> {}

export const memorialApi = {
  async getMemorials(getAccessTokenSilently: () => Promise<string>): Promise<{ memorials: Memorial[] }> {
    const token = await getAccessTokenSilently()
    const response = await fetch(`${API_BASE_URL}/v1/memorial`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`Failed to fetch memorials: ${response.statusText}`)
    }

    return response.json()
  },

  async createMemorial(memorial: CreateMemorialData, getAccessTokenSilently: () => Promise<string>): Promise<{ memorial: Memorial }> {
    const token = await getAccessTokenSilently()
    const response = await fetch(`${API_BASE_URL}/v1/memorial`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(memorial),
    })

    if (!response.ok) {
      throw new Error(`Failed to create memorial: ${response.statusText}`)
    }

    return response.json()
  },

  async updateMemorial(id: string, updates: UpdateMemorialData, getAccessTokenSilently: () => Promise<string>): Promise<{ memorial: Memorial }> {
    const token = await getAccessTokenSilently()
    const response = await fetch(`${API_BASE_URL}/v1/memorial/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updates),
    })

    if (!response.ok) {
      throw new Error(`Failed to update memorial: ${response.statusText}`)
    }

    return response.json()
  },

  async deleteMemorial(id: string, getAccessTokenSilently: () => Promise<string>): Promise<void> {
    const token = await getAccessTokenSilently()
    const response = await fetch(`${API_BASE_URL}/v1/memorial/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`Failed to delete memorial: ${response.statusText}`)
    }
  },
}
